import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGoogletranslateComponent } from './simple-icons-googletranslate.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGoogletranslateComponent ],
    exports:      [ SimpleIconsGoogletranslateComponent ],
    bootstrap:    []
})
export class SimpleIconsGoogletranslateModule {}
